export const RATE_ACTION_TYPES = {
  FETCH_RATE_REQUEST: "FETCH_RATE_REQUEST",
  FETCH_RATE_SUCCESS: "FETCH_RATE_SUCCESS",
  FETCH_RATE_FAILURE: "FETCH_RATE_FAILURE"
};
